'use client'

import { DEFAULT_FLAG_ENTRY } from '../core/types'
import type { FlagEntry } from '../core/types'
import { useFlagContext } from './flag-provider'

export function useFlagsCompat<K extends string>(keys: readonly K[]): Record<K, FlagEntry> {
  const flags = useFlagContext()

  const result = {} as Record<K, FlagEntry>
  for (const key of keys) {
    result[key] = flags[key] ?? DEFAULT_FLAG_ENTRY
  }
  return result
}
